<template>
  <div class="app-container">
    <el-row class="search-condition">
      <el-form ref="queryform" :model="queryParams" :inline="true" label-position="left" size="small">
        <el-form-item label="名称">
          <el-input v-model="queryParams.keyWord" placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" v-preventReClick @click="handleQuery">查询</el-button>
          <el-button v-preventReClick @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button v-if="aclList.indexOf('Add') != -1" type="primary" icon="el-icon-plus" size="small" v-preventReClick
          @click="handleAdd">新增</el-button>
      </el-col>
    </el-row>

    <el-table v-loading="loading" :data="tableData" :max-height="tableHeight" border
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" fixed width="50" align="center" />
      <el-table-column label="名称" align="center" prop="name" />
      <el-table-column label="表单名称" align="center" prop="moduleName" />
      <el-table-column label="备注" align="center" prop="remark" />

      <el-table-column label="操作" fixed="right" align="center" width="180" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button size="mini" type="text" icon="el-icon-edit" v-preventReClick @click="handleUpdate(scope.row)"
            v-hasPermi="['system:user:edit']">查看</el-button>
          <el-button v-if="aclList.indexOf('Remove') != -1" size="mini" type="text" icon="el-icon-delete"
            v-preventReClick @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageIndex" :limit.sync="queryParams.pageSize" @pagination="getData" /> -->

    <!-- <div class="workflowList">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 流程列表
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-button type="primary" icon="el-icon-plus" v-preventReClick
            @click="Add">新增</el-button>
      </div>
      <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header" @selection-change="handleSelectionChange">
        
        <el-table-column fixed prop="name" label="名称"></el-table-column>
        <el-table-column prop="moduleName" label="模块名称"></el-table-column>
        <el-table-column prop="remark" label="描述"></el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">{{
            new Date(scope.row.createdTime).format('yyyy-MM-dd hh:mm:ss')
          }}</template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit" v-preventReClick
            @click="showEditDialog(scope.row)">查看</el-button>
            <el-button type="text" icon="el-icon-delete" class="red" v-preventReClick
            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background layout="total, prev, pager, next" :current-page="query.pageIndex" :page-size="query.pageSize" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
      </div> -->
    <el-drawer :title="title" :visible.sync="open" direction="rtl" :destroy-on-close="true" size="100%" :modal="false"
      :before-close="handleClose">
      <!-- <el-dialog width="100%" class="wfDialog" :title="isAdd ? '新增流程' : '编辑流程'" :visible.sync="open" @close="Close"> -->
      <div class="drag">
        <div class="form">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="流程名称">
              <el-input v-model="formInline.name" placeholder="流程名称"></el-input>
            </el-form-item>
            <el-form-item label="表单">
              <el-select v-model="formInline.tableCode" placeholder="请选择" @change="getAttrList">
                <el-option v-for="item in moduleList" :key="item.id" :label="item.name" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="formInline.remark" placeholder="备注"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" v-preventReClick @click="save">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="bottom">
          <div class="siderMenu">
            <div class="siderItem" data-type="start" @dragstart="copyStart" @dragend="dragEnd" draggable="true">
              开始
            </div>
            <div class="siderItem" data-type="fillSheet" @dragstart="copyStart" @dragend="dragEnd" draggable="true">
              发起节点
            </div>
            <div class="siderItem" data-type="operation" @dragstart="copyStart" @dragend="dragEnd" draggable="true">
              审批节点
            </div>
            <div class="siderItem" data-type="sendMessage" @dragstart="copyStart" @dragend="dragEnd" draggable="true">
              抄送节点
            </div>
            <div class="siderItem" data-type="end" @dragstart="copyStart" @dragend="dragEnd" draggable="true">
              结束
            </div>
          </div>
          <div class="right">
            <div class="dragMain">
              <div class="dragArea" @drop.prevent="drop" @dragover.prevent>
                <flowchart :nodes="nodes" :connections="connections" @editnode="handleEditNode" :width="'100%'"
                  :height="'100%'" :readonly="false" @editconnection="handleEditConnection" @save="handleChartSave"
                  ref="chart"></flowchart>
              </div>
              <div class="select">
                <node-dialog :visible.sync="nodeDialogVisible" :node.sync="nodeForm.target" :approvers="userList"
                  :attrList="attrList" @getApproverList="getUsers"></node-dialog>
                <NodeDialogBySendMessage :visible.sync="nodeDialogCsVisible" :node.sync="nodeForm.target"
                  :approvers="userList" :attrList="attrList" @getApproverList="getUsers"></NodeDialogBySendMessage>
                <connection-dialog :visible.sync="connectionDialogVisible" :connection.sync="connectionForm.target"
                  :operation="connectionForm.operation" :attrList="attrList"></connection-dialog>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- </el-dialog> -->
    </el-drawer>
  </div>
</template>

<script>
import ConnectionDialog from "./_ConnectionDialog";
import NodeDialog from "./_NodeDialog";
import NodeDialogBySendMessage from "./_NodeDialogBySendMessage";
import Flowchart from "./flowchart/Flowchart";
import GetDataMixin from "@/mixin/getData-mixin";
import {
  GetWorkFlowTemps,
  GetModules,
  GetUserList,
  SaveWorkFlowTemp,
  GetWorkFlowTempById,
  UpdateWorkFlowTempStatesById,
  GetApproveConditionKeys,
} from "@/api";

export default {
  name: "drag",
  mixins: [GetDataMixin],
  components: {
    ConnectionDialog,
    NodeDialog,
    NodeDialogBySendMessage,
    Flowchart,
  },
  data: function () {
    return {
      //
      tableData: [],
      total: 0,
      queryParams: {
        keyWord: "",
        pageIndex: 1,
        pageSize: 10,
      },
      open: false,
      title: "",
      multipleSelection: [],
      formInline: {},
      attrList: [],
      nodes: [],
      connections: [],
      // 节点宽度
      codeWidth: 150,
      // 节点高度
      codeHeight: 50,
      // 流程编辑
      defaultNodes: [],
      defaultConnections: [],
      nodeForm: { target: null },
      connectionForm: { target: null, operation: null },
      nodeDialogVisible: false,
      nodeDialogCsVisible: false,
      connectionDialogVisible: false,
      moduleList: [],
      userList: [],
      aclList: [],
    };
  },
  async mounted () { },
  created () {
    this.getData();
    this.getModules();
    this.getUsers("");
    this.init();
    this.aclList = this.getTableAcl("WorkFlowTemp");
  },
  methods: {
    // 表格事件
    getData () {
      this.loading = true;
      GetWorkFlowTemps(this.queryParams).then((res) => {
        if (res && res.returnData) {
          this.tableData = res.returnData.data;
        }
        this.total = res.returnData.totalCount;
        this.loading = false;
      });
    },
    init () {
      (this.defaultNodes = [
        {
          approvers: [],
          x: 370,
          y: 80,
          type: "start",
          name: "Start",
          code: "start",
          approverIds: "",
          isLeader: 0,
          pageId: "1597046114",
          id: 1597046114,
          width: this.codeWidth,
          height: this.codeHeight,
        },
        {
          approvers: [],
          x: 370,
          y: 520,
          type: "end",
          name: "End",
          code: "end",
          approverIds: "",
          isLeader: 0,
          pageId: "1597046120",
          id: 1597046120,
          width: this.codeWidth,
          height: this.codeHeight,
        },
        {
          approvers: [],
          x: 370,
          y: 230,
          type: "fillSheet",
          name: "手工节点",
          code: "code1",
          approverIds: "",
          isLeader: 0,
          pageId: "1597046124",
          id: 1597046124,
          width: this.codeWidth,
          height: this.codeHeight,
        },
        {
          approvers: [],
          x: 370,
          y: 380,
          type: "operation",
          name: "审批节点",
          code: "code4",
          approverIds: "",
          isLeader: 1,
          pageId: "1597046127",
          id: 1597046127,
          width: this.codeWidth,
          height: this.codeHeight,
        },
      ]),
        (this.defaultConnections = [
          {
            type: "pass",
            souce: "1597046114",
            soucePosition: "bottom",
            dest: "1597046124",
            destPosition: "top",
            conditionKey: null,
            conditionType: 0,
            conditionValue: null,
            pageId: "1597046132",
            id: 1597046132,
            source: {
              id: "1597046114",
              position: "bottom",
            },
            destination: {
              id: "1597046124",
              position: "top",
            },
          },
          {
            type: "pass",
            souce: "1597046124",
            soucePosition: "bottom",
            dest: "1597046127",
            destPosition: "top",
            conditionKey: "",
            conditionType: 1,
            conditionValue: "0",
            pageId: "1597046150",
            id: 1597046150,
            source: {
              id: "1597046124",
              position: "bottom",
            },
            destination: {
              id: "1597046127",
              position: "top",
            },
          },
          {
            type: "pass",
            souce: "1597046127",
            soucePosition: "bottom",
            dest: "1597046120",
            destPosition: "top",
            conditionKey: null,
            conditionType: 0,
            conditionValue: null,
            pageId: "1597046154",
            id: 1597046154,
            source: {
              id: "1597046127",
              position: "bottom",
            },
            destination: {
              id: "1597046120",
              position: "top",
            },
          },
        ]);
    },
    getModules () {
      GetModules({ type: 3, pageIndex: 1, pageSize: 100 }).then((res) => {
        this.moduleList = res.returnData.data;
      });
    },
    getUsers (keyWord) {
      GetUsers({ pageIndex: 1, pageSize: 100, keyWord: keyWord }).then(
        (res) => {
          this.userList = res.returnData.data;
        }
      );
    },
    getAttrList (code) {
      GetApproveConditionKeys({ code: code }).then((res) => {
        this.attrList = res.returnData;
      });
    },
    handleAdd () {
      this.title = "新增";
      this.open = true;
      // this.editMode = true;
      this.nodes = this.defaultNodes;
      this.connections = this.defaultConnections;
      this.formInline = {
        id: 0,
        name: "",
        tableCode: "",
        remark: "",
        isAdmin: 0,
      };
    },
    handleClose () {
      this.open = false;
      this.nodes = [];
      this.connections = [];
      this.getData();
    },
    handleUpdate (row) {
      this.getAttrList(row.tableCode);
      GetWorkFlowTempById({ id: row.id }).then((res) => {
        this.editVisible = true;
        this.nodes = res.returnData.nodes.map((item) => {
          if (!item.approvers) {
            item.approvers = [];
          } else {
            item.approvers.map((app) => {
              var users = this.userList.filter((e) => e.id == app.id);
              if (!users || users.length == 0) {
                this.userList.push(app);
              }
            });
          }
          return item;
        });
        this.connections = res.returnData.connections.map((item) => {
          let obj = item;
          obj.source = { id: item.souce, position: item.soucePosition };
          obj.destination = { id: item.dest, position: item.destPosition };
          obj.conditionKey = item.conditionKey;
          obj.conditionType = item.conditionType;
          obj.conditionValue = item.conditionValue;
          return obj;
        });
        console.log(this.connections);
        this.formInline.tableCode = res.returnData.tableCode;
        this.formInline.name = res.returnData.name;
        this.formInline.remark = res.returnData.remark;
        this.open = true;
        this.title = "修改";
      });
    },
    handleDelete (row) {
      this.$my_confirm("确定要删除吗？", "提示", { type: "warning" })
        .then(() => {
          return RemoveWorkFlowTemp({ ids: [row.id] });
          // this.axios
          //   .get(`${this.baseConfig.ServerHost}/WorkFlow/RemoveWorkFlowTemp?code=${row.tableName}`)
          //   .then(res => {
          //     if (res.data.successful) {
          //       this.$my_message('删除成功',"success")
          //     } else {
          //       this.$my_message('删除失败',"error")
          //     }
          //     this.getData()
          //   })
        })
        .then((res) => {
          if (res.successful) {
            this.$my_message("删除成功", "success");
          }
        })
        .then(() => {
          this.getData();
        })
        .catch(() => { });
    },
    handleSelectionChange () {
      this.multipleSelection = val;
    },
    handleQuery () {
      this.getData();
    },
    resetQuery () {
      this.resetQueryParams();
      this.handleQuery();
    },
    // 重置搜索
    resetQueryParams () {
      this.queryParams = {
        pageIndex: this.queryParams.pageIndex,
        pageSize: this.queryParams.pageSize,
      };
      this.resetForm("queryForm");
    },
    handlePageChange (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    // 流程设计方法
    copyStart (ev) {
      let info = { id: ev.target.id, isDrop: true };
      ev.dataTransfer.setData("Text", JSON.stringify(info));
      this.offsetX = ev.offsetX;
      this.offsetY = ev.offsetY;
    },
    drop (e) {
      let info = JSON.parse(e.dataTransfer.getData("Text"));
    },
    dragEnd (event) {
      let type = event.target.dataset.type;
      let name = "";
      let code = "";
      if (type === "fillSheet") {
        name = "手工";
        code = "sponsor_code";
      } else if (type === "start") {
        name = "Start";
        code = "start";
      } else if (type === "end") {
        name = "End";
        code = "end";
      } else {
        // 抄送和审批节点
        name = type == "operation" ? "审批" : "抄送";
        code = "code" + (this.nodes.length - 1);
      }

      this.$refs.chart.add({
        id: this.getId(),
        x: event.pageX - 200,
        y: event.pageY - 110,
        name: name,
        type: type,
        code: code,
        approvers: [],
        width: this.codeWidth,
        height: this.codeHeight,
      });
      event.dataTransfer.clearData();
    },
    getId () {
      let date = new Date().getTime();
      return parseInt(date / 1000);
    },
    // 拖拽
    save () {
      this.$refs.chart.save();
    },
    handleDblClick (position) {
      this.$refs.chart.add({
        id: this.getId(),
        x: position.x,
        y: position.y,
        name: "New",
        type: "operation",
        approvers: [],
        width: this.codeWidth,
        height: this.codeHeight,
      });
    },
    async handleChartSave (nodes, connections) {
      console.log(JSON.stringify(connections));
      console.log(JSON.stringify(nodes));

      let connectArr = connections.map((item) => {
        let obj = {
          type: item.type,
          souce: item.source.id,
          soucePosition: item.source.position,
          dest: item.destination.id,
          destPosition: item.destination.position,
          conditionKey: item.conditionKey,
          conditionType: item.conditionType,
          conditionValue: item.conditionValue,
          id: item.id,
        };
        return obj;
      });
      console.log("变换之后", connectArr);
      // return
      // let ids = null
      // for (let item of nodes) {
      //   item.approvers && (ids = item.approvers.map(list => {
      //     return list.id
      //   }))
      //   item.approverIds = ids.join(';')
      //   ids = null
      // }
      let startNum = nodes.filter((item) => item.type == "start").length;
      let endNum = nodes.filter((item) => item.type == "end").length;
      let fillSheetNum = nodes.filter((item) => item.type == "fillSheet")
        .length;
      if (this.formInline.name.trim() == "") {
        this.$my_message("请输入流程名称", "warning");
        return;
      }
      if (this.formInline.tableCode.trim() == "") {
        this.$my_message("请选择表单", "warning");
        return;
      }
      if (startNum < 1 || startNum > 1) {
        this.$my_message("必须且只能有一个起始节点", "warning");
        return;
      }
      if (endNum < 1 || endNum > 1) {
        this.$my_message("必须且只能有一个结束节点", "warning");
        return;
      }
      if (fillSheetNum < 1 || fillSheetNum > 1) {
        this.$my_message("必须且只能有一个发起人节点", "warning");
        return;
      }
      let obj = {
        nodes: nodes,
        connections: connectArr,
        tableCode: this.formInline.tableCode,
        name: this.formInline.name,
        remark: this.formInline.remark,
      };
      SaveWorkFlowTemp(obj).then((res) => {
        this.$my_message("保存成功", ".success");
        this.getData();
        this.formInline.name = "";
        this.formInline.tableCode = "";
        this.formInline.remark = "";
        this.open = false;
      });
    },
    handleEditNode (node) {
      this.nodeForm.target = node;
      if (node.type === "operation") {
        this.nodeDialogVisible = true;
        this.nodeDialogCsVisible = false;
      } else {
        this.nodeDialogVisible = false;
        this.nodeDialogCsVisible = true;
      }
      this.connectionDialogVisible = false;
    },
    handleEditConnection (connection) {
      console.log("线", connection);
      this.connectionForm.target = connection;
      this.connectionDialogVisible = true;
      this.nodeDialogVisible = false;
      this.nodeDialogCsVisible = false;
    },
  },
};
</script>
<style scoped>
.drag {
  display: flex;
  width: 100%;
  height: 100vh;
  flex-direction: column;
}

.siderMenu {
  width: 100px;
  height: 100%;
  overflow: scroll;
  overflow-x: hidden;
  position: relative;
}

.siderItem {
  text-align: center;
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  position: relative;
  cursor: move;
  -moz-user-select: none;
  /*火狐*/
  -webkit-user-select: none;
  /*webkit浏览器*/
  -ms-user-select: none;
  /*IE10*/
  -khtml-user-select: none;
  /*早期浏览器*/
  user-select: none;
}

/* .siderItem:first-child {
  left: 0;
  top: 0;
}
.siderItem:nth-child(2) {
  left: 0;
  top: 40px;
}
.siderItem:last-child {
  left: 0;
  top: 80px;
} */
.bottom {
  display: flex;
  flex: 1;
  height: 100%;
}

.right {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.drag .form {
  height: 60px;
  padding-left: 200px;
}

.right .dragMain {
  flex: 1;
  height: 100%;
}

.dragMain {
  display: flex;
}

.dragArea {
  flex: 1;
  height: 100%;
  /* width: calc(100% - 400px); */
}
</style>
